import { useState, useEffect } from 'react';
import logo from '../assets/logo.png';

const LINKS = [
  { id:'home',           label:'Home'           },
  { id:'about',          label:'About Us'       },
  { id:'how-it-works',   label:'How It Works'   },
  { id:'for-citizens',   label:'For Citizens'   },
  { id:'for-businesses', label:'For Businesses' },
  { id:'contact',        label:'Contact'        },
];

export default function NavBar({ page, go }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <header className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="flag" style={{ height:3 }}><span /><span /><span /></div>

      <div className="inner">
        <button className="brand" onClick={() => { go('home'); setOpen(false); }}>
          <img src={logo} alt="YojanaSaathi" />
          <div>
            <div className="brand-name">YojanaSaathi</div>
            <div className="brand-sub">योजना साथी</div>
          </div>
        </button>

        <nav className="links">
          {LINKS.map(l => (
            <button key={l.id} className={`nav-link${page===l.id?' active':''}`} onClick={()=>go(l.id)}>
              {l.label}
            </button>
          ))}
          <button className="nav-cta" onClick={()=>go('contact')}>Get Started →</button>
        </nav>

        <button className="burger" onClick={()=>setOpen(o=>!o)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>

      {open && (
        <div className="drawer">
          {LINKS.map(l => (
            <button key={l.id} className={`d-link${page===l.id?' active':''}`} onClick={()=>{go(l.id);setOpen(false);}}>
              {l.label}
            </button>
          ))}
          <button className="d-cta" onClick={()=>{go('contact');setOpen(false);}}>Get Started</button>
        </div>
      )}
    </header>
  );
}
